import { AvatarStyles, AvatarTemplate } from "@fluentui/web-components";
import { DesignSystem } from "../design-system.js";
import { Avatar } from "./avatar.js";
/**
 * The Fabric Avatar component.
 *
 * @public
 */
export const definition = Avatar.compose({
    name: `${DesignSystem.prefix}-avatar`,
    template: AvatarTemplate,
    styles: AvatarStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=avatar.definition.js.map